"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// & T extends { coordinates: unknown } ? { position: Position } : {}
// & T extends Point ? { gatewayStaticstics: { string: HistoryStore } } : {}
